// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import CoreMessages from '@core/scripts/components/messages';
import ProductMessages from '../message-list';
import Landmark from '@core/scripts/components//landmark-adapter';
import NitroEventHelper from '@core/scripts/helper/nitro-event-helper';
import NitroEventFactory from '../../tracking/nitro-event-factory';
import AvailabilityStatusMapper from '../../helper/availability-status-mapper';
import {SliderTypes} from '../recommendations/slider-types';
import OpenGraphMetaTagHelper from '../../helper/open-graph-meta-tag-helper.js';
import {BenefitSectionItemAttributes} from "../../features/benefitsection/benefit-section-item-attribute.ts";
import {Selection} from '@bonprix/design-system';

export default function ItemSelection({texts, product, currentItem, currentItemOption, currentStyle}) {

    const handleBenefitItemAttributes = (newItemOption, item) => {
        const attributes = [];
        if (newItemOption) {
            if (!newItemOption.parcelShopDelivery) {
                attributes.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        } else {
            if (item.itemOptions.some(option => !option.parcelShopDelivery)) {
                attributes.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        }
        MessageBroker.publish(ProductMessages.BENEFIT_ITEM_HIDE_IF_MISSING, {attributes});
    };

    const onChangeItem = (item) => {
        if (currentItem?.id !== item.id) {
            const previousItemOption = currentItemOption;
            let newItemOption = null;
            if (previousItemOption) {
                newItemOption =
                    item.itemOptions.find((itemOption) => itemOption.name === previousItemOption.name) || null;
            }

            const availability = AvailabilityStatusMapper.mapToAvailabilityStatus(
                (newItemOption || item)?.availability
            );
            const landmarkData = `adp\\color\\\\${item.itemNumber}\\${availability}\\${product.channelId}\\${product.shopId}\\${product.masterStyleId}\\${product.styleId}\\${item.id}`;
            const data = {
                click: landmarkData,
            };
            Landmark.sendUserInterfaceLandmark(data);

            MessageBroker.publish(ProductMessages.CHANGED, {item, itemOption: newItemOption});
            MessageBroker.publish(CoreMessages.RECOMMENDATIONS.ITEM_CHANGED, {
                itemNumber: item.itemNumber,
                types: [SliderTypes.DEFAULT, SliderTypes.COMPLEMENTARY_ARTICLES, SliderTypes.OUTFIT],
            });

            handleBenefitItemAttributes(newItemOption, item);

            NitroEventHelper.trigger(
                NitroEventHelper.EventType.DISPLAY_PRODUCT_DETAILS,
                NitroEventFactory.createDisplayProductDetailsEvent(product, currentStyle, item, newItemOption)
            );

            OpenGraphMetaTagHelper.updateImageMetaTag(item);
            MessageBroker.publish(CoreMessages.WISHLIST_ITEM_CHANGE, {productId: product.styleId, itemId: item.id});
        }
    };

    const isSoldOutForCurrentItemOption = (item, currentItemOption) => {
        return item.itemOptions.find((itemOption) => itemOption.name === currentItemOption?.name)?.availability
            ?.soldOut;
    };

    const renderSelection = () => {
        return (
            <Selection
                imageHeight={98}
                imageWidth={70}
                label={texts.bff_ada_farbe_auswahl}
                variant="image"
                value={currentItem?.name}
                onChange={(value) => {
                    const selectedItem = currentStyle.items.find((item) => item.name === value);
                    if (selectedItem) onChangeItem(selectedItem);
                }}
            >
                {currentStyle.items.map((item, index) => {
                    const srcSet = item.image.sources[0]?.srcSet?.src && item.image.sources[0]?.srcSet?.src2x ? {
                        s: `${item.image.sources[0].srcSet.src} 1x, ${item.image.sources[0].srcSet.src2x} 2x`
                    } : {};
                    const isItemSoldOutInCurrentItemOption = isSoldOutForCurrentItemOption(item, currentItemOption);
                    const soldOut = item.availability?.soldOut || isItemSoldOutInCurrentItemOption;
                    return (
                        <Selection.Item
                            key={index}
                            alt={item.name}
                            value={item.name}
                            defaultSrc={item.image?.fallbackSource?.srcSet?.src}
                            srcSet={srcSet}
                            availability={soldOut ? "out-of-stock" : undefined}
                        >
                            {currentItem?.name}
                        </Selection.Item>
                    );
                })}
            </Selection>
        );
    };

    return (
        <div className="product__colors">
            <span className="w-full flex mb-2 px-2 lg:px-0 xl:px-0">
                {renderSelection()}
            </span>
        </div>
    );
}
